// extracted by mini-css-extract-plugin
export default {"field":"preview-field_field__DnAKR","label":"preview-field_label__TShp6","discount":"preview-field_discount__VxmWi"};